import { render, staticRenderFns } from "./ModalFavoriteContactsV2.vue?vue&type=template&id=5fc5d982&scoped=true&"
import script from "./ModalFavoriteContactsV2.vue?vue&type=script&lang=js&"
export * from "./ModalFavoriteContactsV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalFavoriteContactsV2.vue?vue&type=style&index=0&id=5fc5d982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5d982",
  null
  
)

export default component.exports